import React from 'react'

/* Templates */
import PageLayout from 'components_new/templates/PageLayout'

/* Pages */
import Feed from './Feed'
import { RightSidebar } from './RightSidebar'

/* Hooks */
import { useInternalCustomers } from 'redux/hooks/internal/Customers'
import { useParams } from 'utils/hooks'

const CustomerPage = () => {
  const params = useParams<{ id: string }>()

  const { customersById } = useInternalCustomers()

  const customer = customersById[params.id]

  return (
    <PageLayout
      content={{ disablePadding: true, fullWidth: true }}
      rightSidebar={{
        content: <RightSidebar customer={customer} />,
        size: 'medium'
      }}
      variant="feed"
    >
      {customer ? <Feed customer={customer} /> : null}
    </PageLayout>
  )
}

export default CustomerPage
